import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { BaseReactiveFormAdapterClass } from '../../../../classes/base-reactive-form-adapter.class';
import { IWrappedFormComponent } from '@wdx/shared/infrastructure/form-framework';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-reactive-input-lookup',
    templateUrl: './molecule-reactive-input-lookup.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MoleculeReactiveInputLookupComponent),
            multi: true,
        },
    ],
    standalone: false,
})
export class MoleculeReactiveInputLookupComponent
    extends BaseReactiveFormAdapterClass
    implements IWrappedFormComponent
{
    @Input() formData: UntypedFormGroup;
    @Input() formContext: any;

    @Output() blurred = new EventEmitter();

    onBlur() {
        this.onTouched();
        this.blurred.emit();
    }
}
